import { Controller } from "@hotwired/stimulus";

import surveySetup from "./form_functions/surveySetup";
import addNavigation from "./form_functions/addNavigation";

export default class extends Controller {
  static values = {
    formData: { type: Object, default: {} },
    isAdmin: { type: Boolean, default: false },
    defaultResponse: { type: Object, default: {} },
    responseDataUrl: { type: String, default: "" },
    state: { type: String, default: "" },
    responseUrl: { type: String, default: "" },
    completeUrl: { type: String, default: "" },
    uploadUrl: { type: String, default: "" },
    documentsUrl: { type: String, default: "" },
    checkSubmittedUrl: { type: String, default: "" },
    requiredWaDocuments: { type: Array, default: [] },
  };

  static targets = ["surveyContainer"];

  async connect() {
    // dynamically import survey-core and survey-js-ui to avoid loading them on every page for performance
    const [surveyCore, surveyUi] = await Promise.all([
      import("survey-core"),
      import("survey-js-ui"),
    ]);
    const { Model } = surveyCore;
    const { renderSurvey } = surveyUi;

    const surveyModel = new Model(this.formDataValue);

    // Fetch response data via AJAX
    const responseData = await this.fetchResponseData();

    const config = {
      responseData,
      state: this.stateValue,
      defaultResponse: this.defaultResponseValue,
      urls: {
        response: this.responseUrlValue,
        complete: this.completeUrlValue,
        upload: this.uploadUrlValue,
        documents: this.documentsUrlValue,
        checkSubmitted: this.checkSubmittedUrlValue,
      },
      requiredWaDocuments: this.requiredWaDocumentsValue,
    };

    surveySetup(surveyModel, config);

    renderSurvey(surveyModel, this.surveyContainerTarget);

    addNavigation(surveyModel);

    this.addEventListeners();
  }

  async fetchResponseData() {
    if (!this.responseDataUrlValue) {
      return {};
    }

    try {
      const response = await fetch(this.responseDataUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        console.error("Failed to fetch response data:", response.statusText);
        return {};
      }
      const json = await response.json();
      return json.data || {};
    } catch (error) {
      console.error("Error fetching response data:", error);
      return {};
    }
  }

  addEventListeners() {
    if (this.isAdminValue) {
      window.addEventListener("beforeunload", this.beforeUnloadHandler);
    }
  }

  beforeUnloadHandler(event) {
    event.preventDefault();
    event.returnValue = true;
  }
}
